import React from 'react';

const App: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16" fill="none">
      <g fill="currentColor">
        <path d="M8.623 3.901a2 2 0 1 0-1.246 0l-.64 1.44a2 2 0 0 1-2.46 1.085l-1.354-.452a1.5 1.5 0 1 0-1.086.987l.984 4.264a1 1 0 0 0 .975.775h8.409a1 1 0 0 0 .974-.775l.984-4.263a1.5 1.5 0 1 0-1.086-.987l-1.354.45a2 2 0 0 1-2.46-1.084zM3 15a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1z" />
      </g>
    </svg>
  );
};

export const Icons = {
  App,
};
